import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../app/guards'
import { ServiceCollectionsPage } from '../../../features/service/collections-page'
import { serviceCollectionsSearchSchema } from '../../../features/service/search'

export const Route = createFileRoute('/_app/service/collections')({
  staticData: { crumb: 'serviceCollections' },
  // As GET /service/collections: service.read alone opens Service, not the collections queue.
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'service.collect', 'service.verify_payments', 'service.manage'),
  validateSearch: serviceCollectionsSearchSchema,
  component: ServiceCollectionsPage,
})
